export const UsdpAbi = [
  {
    constant: true,
    inputs: [],
    name: 'name',
    outputs: [{name: '', type: 'string', internalType: 'string'}],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'assetProtectionRole',
    outputs: [{name: '', type: 'address', internalType: 'address'}],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'decimals',
    outputs: [{name: '', type: 'uint8', internalType: 'uint8'}],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'paused',
    outputs: [{name: '', type: 'bool', internalType: 'bool'}],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'owner',
    outputs: [{name: '', type: 'address', internalType: 'address'}],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'symbol',
    outputs: [{name: '', type: 'string', internalType: 'string'}],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'betaDelegateWhitelister',
    outputs: [{name: '', type: 'address', internalType: 'address'}],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'proposedOwner',
    outputs: [{name: '', type: 'address', internalType: 'address'}],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'EIP712_DOMAIN_HASH',
    outputs: [{name: '', type: 'bytes32', internalType: 'bytes32'}],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'supplyController',
    outputs: [{name: '', type: 'address', internalType: 'address'}],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    anonymous: false,
    inputs: [
      {indexed: true, name: 'from', type: 'address', internalType: 'address'},
      {indexed: true, name: 'to', type: 'address', internalType: 'address'},
      {indexed: false, name: 'value', type: 'uint256', internalType: 'uint256'},
    ],
    name: 'Transfer',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {indexed: true, name: 'owner', type: 'address', internalType: 'address'},
      {
        indexed: true,
        name: 'spender',
        type: 'address',
        internalType: 'address',
      },
      {indexed: false, name: 'value', type: 'uint256', internalType: 'uint256'},
    ],
    name: 'Approval',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'currentOwner',
        type: 'address',
        internalType: 'address',
      },
      {
        indexed: true,
        name: 'proposedOwner',
        type: 'address',
        internalType: 'address',
      },
    ],
    name: 'OwnershipTransferProposed',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'oldProposedOwner',
        type: 'address',
        internalType: 'address',
      },
    ],
    name: 'OwnershipTransferDisregarded',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'oldOwner',
        type: 'address',
        internalType: 'address',
      },
      {
        indexed: true,
        name: 'newOwner',
        type: 'address',
        internalType: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {anonymous: false, inputs: [], name: 'Pause', type: 'event'},
  {anonymous: false, inputs: [], name: 'Unpause', type: 'event'},
  {
    anonymous: false,
    inputs: [
      {indexed: true, name: 'addr', type: 'address', internalType: 'address'},
    ],
    name: 'AddressFrozen',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {indexed: true, name: 'addr', type: 'address', internalType: 'address'},
    ],
    name: 'AddressUnfrozen',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {indexed: true, name: 'addr', type: 'address', internalType: 'address'},
    ],
    name: 'FrozenAddressWiped',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'oldAssetProtectionRole',
        type: 'address',
        internalType: 'address',
      },
      {
        indexed: true,
        name: 'newAssetProtectionRole',
        type: 'address',
        internalType: 'address',
      },
    ],
    name: 'AssetProtectionRoleSet',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {indexed: true, name: 'to', type: 'address', internalType: 'address'},
      {indexed: false, name: 'value', type: 'uint256', internalType: 'uint256'},
    ],
    name: 'SupplyIncreased',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {indexed: true, name: 'from', type: 'address', internalType: 'address'},
      {indexed: false, name: 'value', type: 'uint256', internalType: 'uint256'},
    ],
    name: 'SupplyDecreased',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'oldSupplyController',
        type: 'address',
        internalType: 'address',
      },
      {
        indexed: true,
        name: 'newSupplyController',
        type: 'address',
        internalType: 'address',
      },
    ],
    name: 'SupplyControllerSet',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {indexed: true, name: 'from', type: 'address', internalType: 'address'},
      {indexed: true, name: 'to', type: 'address', internalType: 'address'},
      {indexed: false, name: 'value', type: 'uint256', internalType: 'uint256'},
      {indexed: false, name: 'seq', type: 'uint256', internalType: 'uint256'},
      {indexed: false, name: 'fee', type: 'uint256', internalType: 'uint256'},
    ],
    name: 'BetaDelegatedTransfer',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'oldWhitelister',
        type: 'address',
        internalType: 'address',
      },
      {
        indexed: true,
        name: 'newWhitelister',
        type: 'address',
        internalType: 'address',
      },
    ],
    name: 'BetaDelegateWhitelisterSet',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'newDelegate',
        type: 'address',
        internalType: 'address',
      },
    ],
    name: 'BetaDelegateWhitelisted',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: 'oldDelegate',
        type: 'address',
        internalType: 'address',
      },
    ],
    name: 'BetaDelegateUnwhitelisted',
    type: 'event',
  },
  {
    constant: false,
    inputs: [],
    name: 'initialize',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [],
    name: 'initializeDomainSeparator',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'totalSupply',
    outputs: [{name: '', type: 'uint256', internalType: 'uint256'}],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {name: '_to', type: 'address', internalType: 'address'},
      {name: '_value', type: 'uint256', internalType: 'uint256'},
    ],
    name: 'transfer',
    outputs: [{name: '', type: 'bool', internalType: 'bool'}],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: true,
    inputs: [{name: '_addr', type: 'address', internalType: 'address'}],
    name: 'balanceOf',
    outputs: [{name: '', type: 'uint256', internalType: 'uint256'}],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {name: '_from', type: 'address', internalType: 'address'},
      {name: '_to', type: 'address', internalType: 'address'},
      {name: '_value', type: 'uint256', internalType: 'uint256'},
    ],
    name: 'transferFrom',
    outputs: [{name: '', type: 'bool', internalType: 'bool'}],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {name: '_spender', type: 'address', internalType: 'address'},
      {name: '_value', type: 'uint256', internalType: 'uint256'},
    ],
    name: 'approve',
    outputs: [{name: '', type: 'bool', internalType: 'bool'}],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: true,
    inputs: [
      {name: '_owner', type: 'address', internalType: 'address'},
      {name: '_spender', type: 'address', internalType: 'address'},
    ],
    name: 'allowance',
    outputs: [{name: '', type: 'uint256', internalType: 'uint256'}],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {name: '_proposedOwner', type: 'address', internalType: 'address'},
    ],
    name: 'proposeOwner',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [],
    name: 'disregardProposeOwner',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [],
    name: 'claimOwnership',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [],
    name: 'reclaimUSDP',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [],
    name: 'pause',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [],
    name: 'unpause',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {
        name: '_newAssetProtectionRole',
        type: 'address',
        internalType: 'address',
      },
    ],
    name: 'setAssetProtectionRole',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [{name: '_addr', type: 'address', internalType: 'address'}],
    name: 'freeze',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [{name: '_addr', type: 'address', internalType: 'address'}],
    name: 'unfreeze',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [{name: '_addr', type: 'address', internalType: 'address'}],
    name: 'wipeFrozenAddress',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: true,

    inputs: [{name: '_addr', type: 'address', internalType: 'address'}],
    name: 'isFrozen',
    outputs: [{name: '', type: 'bool', internalType: 'bool'}],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {name: '_newSupplyController', type: 'address', internalType: 'address'},
    ],
    name: 'setSupplyController',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [{name: '_value', type: 'uint256', internalType: 'uint256'}],
    name: 'increaseSupply',
    outputs: [{name: 'success', type: 'bool', internalType: 'bool'}],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [{name: '_value', type: 'uint256', internalType: 'uint256'}],
    name: 'decreaseSupply',
    outputs: [{name: 'success', type: 'bool', internalType: 'bool'}],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: true,
    inputs: [{name: 'target', type: 'address', internalType: 'address'}],
    name: 'nextSeqOf',
    outputs: [{name: '', type: 'uint256', internalType: 'uint256'}],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {name: 'sig', type: 'bytes', internalType: 'bytes'},
      {name: 'to', type: 'address', internalType: 'address'},
      {name: 'value', type: 'uint256', internalType: 'uint256'},
      {name: 'fee', type: 'uint256', internalType: 'uint256'},
      {name: 'seq', type: 'uint256', internalType: 'uint256'},
      {name: 'deadline', type: 'uint256', internalType: 'uint256'},
    ],
    name: 'betaDelegatedTransfer',
    outputs: [{name: '', type: 'bool', internalType: 'bool'}],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {name: 'r', type: 'bytes32[]', internalType: 'bytes32[]'},
      {name: 's', type: 'bytes32[]', internalType: 'bytes32[]'},
      {name: 'v', type: 'uint8[]', internalType: 'uint8[]'},
      {name: 'to', type: 'address[]', internalType: 'address[]'},
      {name: 'value', type: 'uint256[]', internalType: 'uint256[]'},
      {name: 'fee', type: 'uint256[]', internalType: 'uint256[]'},
      {name: 'seq', type: 'uint256[]', internalType: 'uint256[]'},
      {name: 'deadline', type: 'uint256[]', internalType: 'uint256[]'},
    ],
    name: 'betaDelegatedTransferBatch',
    outputs: [{name: '', type: 'bool', internalType: 'bool'}],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: true,
    inputs: [{name: '_addr', type: 'address', internalType: 'address'}],
    name: 'isWhitelistedBetaDelegate',
    outputs: [{name: '', type: 'bool', internalType: 'bool'}],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      {name: '_newWhitelister', type: 'address', internalType: 'address'},
    ],
    name: 'setBetaDelegateWhitelister',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [{name: '_addr', type: 'address', internalType: 'address'}],
    name: 'whitelistBetaDelegate',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: false,
    inputs: [{name: '_addr', type: 'address', internalType: 'address'}],
    name: 'unwhitelistBetaDelegate',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const;
